import { Container, Row, Col } from "react-bootstrap";
import { useWeb3React } from "@web3-react/core";

import { formattedWallet } from "../../../utils/account";

import CounterItem from "./counterItem/counterItem";

import nftIcon from "../../../assets/nft_icon_white.png";
import tokenIcon from "../../../assets/token_icon_white.png";
// import wheelIcon from "../../../assets/wheel_icon_white.png";

import "./counterItemsStyles.css";

const CounterItems = ({
  geoTokensAmount,
  NFTsAmount,
  // geoSpinsAmount,
  setDisplayBuyGEOTokens,
  onClickConnectWallet,
}) => {
  const { active, account } = useWeb3React();

  return (
    <Container className="counter-items-container pr-0">
      <Row className="counter-items-row align-items-center">
        <Col xs={4} lg="auto" className="px-1">
          <button
            onClick={() => setDisplayBuyGEOTokens(true)}
            className="d-flex align-items-center header-button geos-button justify-content-center w-100"
          >
            <span>Buy GEO$</span>
          </button>
        </Col>
        <Col xs={4} lg="auto" className="px-1">
          <a
            href="/game"
            className="d-flex align-items-center header-button market-button justify-content-center"
          >
            <span>NFT Market</span>
          </a>
        </Col>
        {/* <Col xs={3} lg="auto" className="px-1">
          <a
            href="https://opensea.io/collection/geopoly-nfts-official-collection"
            className="d-flex align-items-center header-button black-friday-button justify-content-center text-center"
          >
            <span>NFT Outlet</span>
          </a>
        </Col> */}
        <Col xs={4} lg="auto" className="px-1">
          {active ? (
            <span className="d-flex align-items-center header-text wallet-button justify-content-center">
              {formattedWallet(account)}
            </span>
          ) : (
            <button
              onClick={() => onClickConnectWallet()}
              className="d-flex align-items-center header-button wallet-button justify-content-center w-100"
            >
              <span>Connect Wallet</span>
            </button>
          )}
        </Col>
        <Col xs={6} lg="auto" className="px-1">
          <CounterItem
            icon={tokenIcon}
            iconAlt="geo-token-icon"
            amount={geoTokensAmount}
            {...(active && { onClick: () => window.open("/staking") })}
          />
        </Col>
        <Col xs={6} lg="auto" className="px-1">
          <CounterItem
            icon={nftIcon}
            iconAlt="nft-icon"
            amount={NFTsAmount}
            {...(active && { onClick: () => window.open("/nft-farming") })}
          />
        </Col>
        {/* <Col xs={4} lg="auto" className="px-1">
          <CounterItem
            icon={wheelIcon}
            iconAlt="wheel-icon"
            amount={geoSpinsAmount}
            {...(active && { onClick: () => window.open("/wheel-of-fortune") })}
          />
        </Col> */}
      </Row>
    </Container>
  );
};

export default CounterItems;
